import Marquee from "react-fast-marquee";
import { Star } from "lucide-react";

const WORDS = [
  "GLOBAL TRADE",
  "PREMIUM TEXTILES",
  "INDIA TO THE WORLD",
  "EXPORT EXCELLENCE",
  "TERRY TOWEL SPECIALISTS",
  "BULK SUPPLY",
];

export const Ribbon = ({ dark = false }) => {
  return (
    <div
      className={`border-y ${dark ? "border-white/10 bg-navy text-white" : "border-black/10 bg-neutral-50 text-navy"} py-5`}
      data-testid="editorial-ribbon"
    >
      <Marquee speed={38} gradient={false} autoFill>
        {WORDS.map((w, i) => (
          <span key={i} className="mx-8 flex items-center gap-8 font-display text-sm font-semibold uppercase tracking-[0.28em]">
            {w}
            <Star className="h-3.5 w-3.5 text-sky" fill="currentColor" />
          </span>
        ))}
      </Marquee>
    </div>
  );
};
